import react from "react";
import { useDispatch } from "react-redux";
import { setLoading } from "../../Store/reducers/pixiCanvasSlice";
import { IoIosClose } from "react-icons/io";

const MainLoader = () => {
  const dispatch = useDispatch();

  return (
    <div
      className={`fixed inset-0 flex items-center justify-center z-[200] ${"bg-black bg-opacity-50"}`}
    >
      <div className=" flex items-center justify-center">
        <div className="bg-white p-5 shadow-lg rounded-md relative w-auto">
          <button
            className="absolute top-1 right-1 w-[25px] h-[25px] flex items-center justify-center text-xl cursor-pointer"
            onClick={() => dispatch(setLoading(false))}
          >
            <IoIosClose />
          </button>

          <div className="flex items-center justify-evenly mt-1">
            <div className="flex items-center justify-between gap-[10px] ">
              <div className="loader w-[22px] h-[22px] animate-spin border-[4px] border-gray-600 border-t-transparent rounded-full"></div>
              <div className="text-[17px] font-semibold">
                Please wait your project is loading
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainLoader;
